// The Firebase project for this build: paidlark-staging by default, the
// production project only for `vite --mode prod` / `npm run build:prod`.
// Web API keys are public by design; the security rules protect the data.
import { type FirebaseApp, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { type Firestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';

const PROJECTS = {
  staging: {
    apiKey: 'AIzaSyCzP-hXg_kx9EFFV4dAP5mNcAPMOvgzGS8',
    appId: '1:435066540646:web:8d6390dea5ce9a11ef53a7',
    messagingSenderId: '435066540646',
    projectId: 'paidlark-staging',
    authDomain: 'paidlark-staging.firebaseapp.com',
    storageBucket: 'paidlark-staging.firebasestorage.app',
  },
  prod: {
    apiKey: 'AIzaSyDbW4MOUGJbi8T6Yxxr86-rhNvKMt_L6aA',
    appId: '1:220603835830:web:bb0b6b9a8f51d886c0cd17',
    messagingSenderId: '220603835830',
    projectId: 'paidlark',
    authDomain: 'paidlark.firebaseapp.com',
    storageBucket: 'paidlark.firebasestorage.app',
  },
};

export const isProduction = import.meta.env.MODE === 'prod';

let app: FirebaseApp | null = null;
let db: Firestore | null = null;

export function firebaseApp(): FirebaseApp {
  app ??= initializeApp(isProduction ? PROJECTS.prod : PROJECTS.staging);
  return app;
}

export const auth = () => getAuth(firebaseApp());

/**
 * Firestore with its cache in the browser, shared by every open tab, so the
 * app works offline: writes apply at once and sync when back online.
 */
export function firestore(): Firestore {
  db ??= initializeFirestore(firebaseApp(), { localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }) });
  return db;
}
